import { useGetMe } from '@/lib/api/me.ts';
import UpdateProfile from '@/features/user/update-profile/UpdateProfile.tsx';

const ProfilePage = () => {
  const { data: currentUser } = useGetMe();
  if (!currentUser) {
    return null;
  }
  return <UpdateProfile currentUser={currentUser} />;
};

export default ProfilePage;
